import LogoPng from '../../../assets/images/logo2.png';
import s from './FooterMobile.module.scss';

const FooterMobile = () => {
  return (
    <footer>
      <div className={s.footerWrapper}>
        <div className={s.logo}>
          <img src={LogoPng} alt="Логотип стоматологической клиники в Москве" />
        </div>
        <div className={s.footerShortInfo}>
          <div className={s.footerShortInfo_message}>Будем рады Вас видеть!</div>
          <div> г. Москва, Одинцово, Нахимовский проспект 65, м.Профсоюзная</div>
          <div>Понедельник-Воскресенье: 10:00-20:00</div>
        </div>
      </div>
    </footer>
  );
};

export default FooterMobile;
